import { render, staticRenderFns } from "./JoaDocSendingForm.vue?vue&type=template&id=161a2557&"
import script from "./JoaDocSendingForm.vue?vue&type=script&lang=js&"
export * from "./JoaDocSendingForm.vue?vue&type=script&lang=js&"
import style0 from "./JoaDocSendingForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports